import { Route } from '@angular/router';
import { ReceiptLookupFormComponent } from './feature/receipt-lookup-form/receipt-lookup-form.component';
import { ReceiptLookupResultsComponent } from './feature/receipt-lookup-result/receipt-lookup-results.component';
import { resultsGuard } from './guards/results-guard';

export const receiptLookupPageRoutes: Route[] = [
    { path: '', component: ReceiptLookupFormComponent },
    { path: 'result', component: ReceiptLookupResultsComponent, canActivate: [resultsGuard] },
];
